import ActionSheet from "components/ActionSheet";
import Translation from "components/Translation";

interface FilterActionSheetProps {
    show: boolean,
    toggleShow(show: boolean): void
    title: string,
    onClear: () => void,
    children: React.ReactNode
}
export default function FilterActionSheet({
    show,
    toggleShow,
    onClear,
    title,
    children
}: FilterActionSheetProps) {

    return (
        <ActionSheet show={show} toggleShow={toggleShow}>
            <div className="flex justify-between py-4 border-b-2">
                <button className="bg-transparent font-light text-primary text-md mx-4" onClick={onClear}>
                    <Translation
                        content_key="clear"
                    />
                </button>
                <span className="text-lg font-black text-primary ">{
                    <Translation
                        content_key={title}
                    />
                }</span>
                <button className="bg-transparent font-light text-primary text-lg mx-4" onClick={() => {
                    toggleShow(false)
                }}>
                    <i className="feather-x text-xl"></i>
                </button>
            </div>
            {children}
        </ActionSheet>
    )

}